<!-- components/forms/CompanySelector.vue -->
<template>
  <div class="space-y-4">
    <h3 class="text-lg font-medium mb-4">Select Company</h3>

    <!-- Company Selection as Radio Cards -->
    <div class="space-y-3">
      <label class="block text-sm font-medium">
        Company <span class="text-red-500">*</span>
      </label>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
        <button
          v-for="company in companies"
          :key="company.value"
          @click="selectCompany(company.value)"
          :class="[
            'p-4 rounded-lg border-2 text-center transition-all flex flex-col items-center justify-center',
            modelValue === company.value
              ? company.selectedClass
              : 'border-gray-200 hover:border-gray-300 ',
          ]"
          type="button"
        >
          <div class="mb-2 flex items-center justify-center">
            <component :is="company.icon" class="w-8 h-8" />
          </div>
          <div class="font-medium">{{ company.label }}</div>
          <div class="text-xs text-gray-500 mt-1">{{ company.description }}</div>
        </button>
      </div>
    </div>

    <!-- Company Selection as Dropdown (Alternative) -->
    <!-- <div class="space-y-2">
      <label class="block text-sm font-medium text-gray-700">
        Or select from dropdown
      </label>
      <select
        :value="modelValue"
        @change="selectCompany(($event.target as HTMLSelectElement).value)"
        class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
      >
        <option value="">-- Select Company --</option>
        <option
          v-for="company in companies"
          :key="company.value"
          :value="company.value"
        >
          {{ company.label }}
        </option>
      </select>
    </div> -->

    <!-- Error Message -->
    <p v-if="error" class="text-red-500 text-sm mt-1">
      {{ error }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { BuildingOfficeIcon, ShoppingBagIcon, HomeModernIcon } from '@heroicons/vue/24/outline'
import type { CompanyType } from '@/types/user'

const companies = [
  {
    value: 'maxstationary' as CompanyType,
    label: 'Max Stationary',
    description: 'Max Stationary Company',
    icon: BuildingOfficeIcon,
    selectedClass: 'bg-amber-50 border-amber-500 text-amber-700',
  },
  {
    value: 'ostnasik' as CompanyType,
    label: 'OST Nasik',
    description: 'OST Nasik Branch',
    icon: ShoppingBagIcon,
    selectedClass: 'bg-teal-50 border-teal-500 text-teal-700',
  },
  {
    value: 'shradhha-ent' as CompanyType,
    label: 'Shradhha Ent',
    description: 'Shradhha Enterprises',
    icon: HomeModernIcon,
    selectedClass: 'bg-indigo-50 border-indigo-500 text-indigo-700',
  },
]

defineProps<{
  modelValue?: CompanyType | undefined
  error?: string
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
  (e: 'change', value: string): void
}>()

const selectCompany = (value: string) => {
  emit('update:modelValue', value)
  emit('change', value)
}
</script>
